import { executeLambda } from '@olympeio/core';
import { ActionBrick, registerBrick, Application } from 'olympe';

const timestamp = () => { return new Date().toISOString() };

export default class StreamMessageHandler extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} client
     * @param {string} stream
     * @param {string} subscription
     * @param {string} tag
     * @param {*} handler
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     */
    async update($, [client, stream, subscription, tag, handler], [forwardEvent, setErrorFlow]) {
        // Write your code here.
        // Check https://olympe.support for documentation.
        // Check https://github.com/olympeio/CORE for examples.
        //
        // This method is executed every time the brick's input Control Flow is triggered.
        // Override `setupExecution()` to change this behavior.
        console.log("[MACROMETA]:", timestamp(), "MacrometaSubscriber.update() triggered");
        var consumer = null;
        
        const terminate_consumer = () => {
          if (consumer != null) {
            consumer.terminate();
            consumer = null;
            $.set("consumer", null);
            console.debug("[MACROMETA]:", timestamp(), "hearbeat(): connection terminated");
          };
          // Trigger the output Control Flow
          forwardEvent();
          return;
        }

        try {
          consumer = await client.createStreamReader(
            stream,
            subscription,
            false,
            false,
            null,
            {
              //subscriptionType: "Shared",
              receiverQueueSize: 1,
            }
          )
          $.set("consumer", consumer);
        }
        catch(err) { 
          console.error("[MACROMETA]:", timestamp(), err);
          terminate_consumer();
        }

        console.debug("[MACROMETA]:", timestamp(), "Consumer created");

        const heartbeat = () => {
          console.debug("heartbeat");
          clearTimeout($.get('message_timeout'));
          $.set('message_timeout', setTimeout(terminate_consumer, 60000 + 1000));
        }
/*
        const delete_subscription = () => {
          if (consumer != null) {
            consumer.terminate();
            console.debug("[MACROMETA]:", timestamp(), "destroy(): consumer terminated");
          }
          client.deleteStreamSubscription(stream, subscription, false);
          console.log(
            "[MACROMETA]:", timestamp(), `${subscription} subscription deleted successfully from stream ${stream}`
          );
        };
        $.onDestroy(delete_subscription);
*/  
        consumer.on('open', () => {
          console.debug("[MACROMETA]:", timestamp(), "onOpen()");        
          heartbeat();
        });
        consumer.on("close", () => {
          console.debug("[MACROMETA]:", timestamp(), "onClose()");
          //clearTimeout($.get('message_timeout'));
        });
        consumer.on("error", (err) => {
          console.error("[MACROMETA]:", timestamp(), err);
        });

        consumer.on("message", async (msg) => {
            heartbeat();
            const { payload, messageId } = JSON.parse(msg);
            const data = Buffer.from(payload, "base64").toString("ascii")
            
            //console.debug("Message:", data);
            const [results] = await executeLambda(ctx, handler, [tag, payload]);
            
            consumer.send(JSON.stringify({ messageId }));
            console.log("[MACROMETA]:", timestamp(), messageId);
        });
            
    }

    destroy($) {
      const consumer = $.get("consumer");
      if (consumer != null) {
        consumer.terminate();
        console.debug("[MACROMETA]:", timestamp(), "destroy(): consumer terminated");
      }
      const client = $.get("client");
      const stream = $.get("stream");
      const subscription = $.get("subscription");
      client.deleteStreamSubscription(stream, subscription, false);
      console.log(
        "[MACROMETA]:", timestamp(), `${subscription} subscription deleted successfully from stream ${stream}`
      );
    };

}

registerBrick('018f5c777f8eb7f89215', StreamMessageHandler);
